import React from "react";
import { barvaOsoby, inicialy } from "../lib/osoby";

/** Kolečko osoby: fotka, když ji má; jinak iniciály v barvě odvozené z id. */
export default function OsobaKolecko({ id, name, url, size = 24, className = "", ctverec = false }) {
  const tvar = ctverec ? "rounded-[8px]" : "rounded-full";
  if (url) {
    return (
      <img src={url} alt={name || ""} title={name} draggable={false}
        className={`${tvar} object-cover shrink-0 ${className}`} style={{ width: size, height: size }} />
    );
  }
  return (
    <span title={name} className={`${tvar} shrink-0 font-800 text-white inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size, background: barvaOsoby(id), fontSize: Math.round(size * 0.4) }}>
      {inicialy(name)}
    </span>
  );
}
